export default __webpack_public_path__ + "2698c837b129414417850ff5e7d1c178.png";